import { Component, Vue } from 'vue-property-decorator';
import { getComponentProps } from '@/utils/vueUtils';
import { RelatedItemsModuleViewModel, convertToGridConfig } from './RelatedItemsModule.types';
import ContentType from '@/common/interfaces/enums/ContentType';
import { SwiperOptions } from '@/utils/swiperUtils';

import { getResizeImage } from '@/utils/commonUtils';

import GenericCard from '@/components/GenericCard/GenericCard.vue';
import SizeBreakpoints, { BREAKPOINTS } from '@/common/interfaces/SizeBreakpoints';
import { Getter } from 'vuex-class';
import { mixins } from 'vue-class-component';
import SwiperMixin from '@/mixins/SwiperMixin';
import { SegmentElement } from '@/plugins/utm/SegmentElement';

@Component({
  components: {
    GenericCard,
    FilterableGridModule: () => import('@/modules/FilterableGridModule/FilterableGridModule.vue'),
  },
  props: getComponentProps<RelatedItemsModuleViewModel>({
    Title: '',
    TitleSmall: 'Special offers',
    Link: { Title: 'View all articles', Link: '#' },
    Category: '',
    IsGrid: false,
    Items: [
      {
        CardType: 'Itinerary',
        BookLink: '#',
        ViewMoreLink: '#',
        Image: {
          Url: getResizeImage('whale.jpg'),
          Alt: 'Whale',
        },
        Title: 'A remarkable journey to Alaska, British Columbia & Haida gwaii',
        Price: '$10,900',
        Days: 15,
        IsNew: false,
        SpecialOffers: [],
        Highlights: ['Land of mist shrouded fjords', 'Tidewater glaciers'],
        Months: ['May', 'Aug', 'Sep'],
        Locations: ['Alaska'],
        Wishlist: true,
      },
      {
        CardType: 'Article',
        Type: ContentType.Watch,
        Image: { Url: getResizeImage('moose.jpg'), Alt: 'Moose' },
        Date: 'Jun 2019',
        ArticleLink: { Title: 'Small Tracks, Big Impacts...', Link: '#' },
      },
    ],
  }),
})
export default class RelatedItemsModule extends mixins(SwiperMixin) {
  readonly p!: RelatedItemsModuleViewModel;
  wasInteracted = false;

  get swiperOption(): SwiperOptions {
    return {
      spaceBetween: this.threeOrLess ? 0 : 20,
      slidesPerView: this.threeOrLess ? 'auto' : 3.5,
      speed: 250,
      centeredSlides: false,
      loop: false,
      simulateTouch: true,
      freeMode: true,
      wrapperClass: 'swiper-wrapper',
      slideClass: 'swiper-slide',
      observeParents: true,
      observer: true,
      mousewheel: {
        forceToAxis: true,
        invert: true,
      },
      scrollbar: {
        el: `#c-${this.uuid}-swiper-scrollbar`,
        draggable: true,
        snapOnRelease: false,
      },
      breakpoints: {
        // breakpoints work down from these values not up
        [BREAKPOINTS.sm]: {
          freeMode: true,
          slidesPerView: 'auto',
        },
        [BREAKPOINTS.lg]: {
          freeMode: true,
          scrollbar: {
            el: `#c-${this.uuid}-swiper-scrollbar`,
            snapOnRelease: false,
          },
        },
      },
      on: {
        slideChange: () => this.onModuleInteraction('change'),
        touchStart: () => this.onModuleInteraction(),
      },
    };
  }

  onModuleInteraction(type?: string) {
    if (!this.wasInteracted) {
      SegmentElement.sendEvent('moduleInteraction', {
        component_name: this.p.Items[0]?.CardType,
        module_type_id: this.$attrs['data-segmentid'],
        module_type_name: this.$attrs.type,
        interaction_type: 'carousel',
        position: type === 'change' ? this.swiper.activeIndex : this.swiper.activeIndex + 1,
      })
      this.wasInteracted = true;
    }
  }

  // relating to Edge issue where scrolbar drags in the wrong direction as touch screen type is computed incorrectly
  // need this to be incorporated into swiper but can't change the node file as it isn't tracked.
  // works if you replace the touch: section in the swiper.js file (line 971)
  // https://github.com/nolimits4web/swiper/issues/3232

  // touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
  //   return (('ontouchstart' in window)
  //   || (navigator.MaxTouchPoints > 0)
  //   || (navigator.msMaxTouchPoints > 0));
  // }()),

  get threeOrLess() {
    return this.p.Items.length <= 3;
  }

  get fourOrMore() {
    return this.p.Items.length >= 4;
  }

  get Category() {
    const cat = this.p.Category.toLowerCase();
    return cat;
  }

  get isItinerary() {
    return this.p.Items[0]?.CardType === 'Itinerary';
  }

  @Getter isInBreakpoint!: (breakpoints: SizeBreakpoints[] | SizeBreakpoints) => boolean;
  get hideScrollBar() {
    return this.threeOrLess && this.isInBreakpoint(['lg', 'xl', 'xxl']);
  }

  get GridConfig() {
    return convertToGridConfig(this.p);
  }
}
